<template>
    <div class="contract-back">
        <div id="hvpage1" class="hpa" style="width:210mm;height:297mm;">
            <div class="hcD" style="left:19mm;top:20mm;">
            <div class="hcI">
            <div class="hls ps0" style="line-height:263.39mm;white-space:nowrap;left:0mm;top:0mm;height:263.39mm;width:172mm;">
            <div class="htb" style="width:173mm;height:263.39mm;display:inline-block;position:relative;vertical-align:-15%;line-height:263.39mm;">
            <svg class="hs" viewBox="-2.50 -2.50 178 268.39" style="left:-2.50mm;top:-2.50mm;width:178mm;height:268.39mm;">
            <path d="M27.69,28.49 L27.69,220.44" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M53.92,28.49 L53.92,164.36" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M105.92,28.49 L105.92,66.70" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M105.92,138.88 L105.92,164.36" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.15,28.49 L172.16,28.49" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M53.86,36.13 L172.07,36.13" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M27.63,43.77 L172.07,43.77" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M53.86,51.41 L172.07,51.41" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M53.86,59.05 L172.07,59.05" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M27.63,66.69 L172.07,66.69" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,94.59 L53.98,94.59" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M27.63,94.59 L53.98,94.59" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M53.86,94.59 L172.07,94.59" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M53.86,94.59 L172.07,94.59" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M27.63,103.06 L172.07,103.06" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M27.63,112.67 L172.07,112.67" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M27.63,121.13 L172.07,121.13" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,130.39 L172.07,130.39" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M27.63,138.88 L172.07,138.88" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M53.86,147.37 L172.07,147.37" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M53.86,155.86 L172.07,155.86" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,164.36 L172.07,164.36" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,212.71 L172.07,212.71" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,220.43 L172.07,220.43" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,259.62 L172.11,259.62" style="stroke:#808080;stroke-linecap:butt;stroke-width:0.70;">
            </path>
            <path d="M105.92,28.49 L105.92,66.70" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M105.92,138.88 L105.92,164.36" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M27.69,28.49 L27.69,220.44" style="stroke:#4C4C4C;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,259.62 L172.11,259.62" style="stroke:#808080;stroke-linecap:butt;stroke-width:0.70;">
            </path>
            <path d="M-0.15,28.49 L172.16,28.49" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,28.49 L172.06,28.49" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,94.59 L172.06,94.59" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,164.36 L172.06,164.36" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,220.43 L172.06,220.43" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M27.63,130.39 L53.98,130.39" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,130.39 L27.75,130.39" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,164.36 L27.75,164.36" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            <path d="M-0.06,164.36 L27.75,164.36" style="stroke:#000000;stroke-linecap:butt;stroke-width:0.12;">
            </path>
            </svg>
            <div class="hce" style="left:0mm;top:0mm;width:172mm;height:6.76mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:0.09mm;">
            <div class="hls ps23" style="line-height:3.76mm;white-space:nowrap;left:0mm;top:-0.23mm;height:4.59mm;width:170mm;">
            <span class="hrt cs17">■ 국민건강보험법 시행규칙 [별지 제19호의6서식]</span>
            <span class="hrt cs24">&nbsp;</span>
            <span class="hrt cs14">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:0mm;top:6.76mm;width:172mm;height:12.68mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:2.52mm;">
            <div class="hls ps24" style="line-height:4.80mm;white-space:nowrap;left:0mm;top:-0.28mm;height:5.64mm;width:170mm;">
            <span class="hrt cs26">요양비 지급청구 위임장</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:0mm;top:19.43mm;width:172mm;height:9.05mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI">
            <div class="hls ps16" style="line-height:2.17mm;white-space:nowrap;left:0mm;top:-0.14mm;height:2.82mm;width:170mm;">
            </div>
            <div class="hls ps25" style="line-height:2.17mm;white-space:nowrap;left:0mm;top:4.09mm;height:2.82mm;width:170mm;">
            <span class="hrt cs2">※ 뒤쪽의 유의사항을 읽고 작성해 주시기 바라며,&nbsp;</span>
            <span class="hrt cs14">[ &nbsp;]에는 해당되는 곳에 √ 표시를 합니다. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="hrt cs2">(앞쪽)</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:0mm;top:28.49mm;width:27.69mm;height:66.10mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:30.11mm;">
            <div class="hls ps26" style="line-height:3.10mm;white-space:nowrap;left:0mm;top:-0.19mm;height:3.88mm;width:25.68mm;">
            <span class="hrt cs21">① 위임인</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:27.69mm;top:28.49mm;width:26.23mm;height:15.28mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.95mm;">
            <div class="hls ps27" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs18">가입자 또는&nbsp;</span>
            </div>
            <div class="hls ps27" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:6.17mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs18">피부양자</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:28.49mm;width:52mm;height:7.64mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.31mm;">
            <div class="hls ps28" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:50.50mm;">
            <span class="hrt cs18">&nbsp;&nbsp;성명</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:105.92mm;top:28.49mm;width:66.08mm;height:7.64mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.31mm;">
            <div class="hls ps27" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:64.59mm;">
            <span class="hrt cs18">{{ name }}</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:36.13mm;width:52mm;height:7.64mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.31mm;">
            <div class="hls ps28" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:50.50mm;">
            <span class="hrt cs18">&nbsp;&nbsp;주민(외국인)등록번호 &nbsp;</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:105.92mm;top:36.13mm;width:66.08mm;height:7.64mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.31mm;">
            <div class="hls ps27" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:64.59mm;">
            <span class="hrt cs18">8711121-1010210</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:27.69mm;top:43.77mm;width:26.23mm;height:22.92mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:5.77mm;">
            <div class="hls ps27" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs18">법정대리인&nbsp;</span>
            </div>
            <div class="hls ps27" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:6.17mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs18">또는 가족</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:43.77mm;width:52mm;height:7.64mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.31mm;">
            <div class="hls ps28" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:50.50mm;">
            <span class="hrt cs18">&nbsp;&nbsp;성명</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:105.92mm;top:43.77mm;width:66.08mm;height:7.64mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.31mm;">
            <div class="hls ps27" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:64.59mm;">
            <span class="hrt cs18">이승도</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:51.41mm;width:52mm;height:7.64mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.31mm;">
            <div class="hls ps28" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:50.50mm;">
            <span class="hrt cs18">&nbsp;&nbsp;생년월일</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:105.92mm;top:51.41mm;width:66.08mm;height:7.64mm;">
            <div class="hcD" style="left:1mm;top:1.31mm;">
            <div class="hcI">
            <div class="hls ps27" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:64.59mm;">
            <span class="hrt cs18">1987</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:59.05mm;width:52mm;height:7.64mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.31mm;">
            <div class="hls ps28" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:50.50mm;">
            <span class="hrt cs18">&nbsp;&nbsp;가입자ㆍ피부양자와의 관계&nbsp;</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:105.92mm;top:59.05mm;width:66.08mm;height:7.64mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.31mm;">
            <div class="hls ps27" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:64.59mm;">
            <span class="hrt cs18">부</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:27.69mm;top:66.69mm;width:26.23mm;height:27.90mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:6.04mm;">
            <div class="hls ps27" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs18">전화번호</span>
            </div>
            <div class="hls ps18" style="line-height:2.48mm;white-space:nowrap;left:0mm;top:6.19mm;height:3.17mm;width:24.74mm;">
            <span class="hrt cs28">(위임사항 및&nbsp;</span>
            </div>
            <div class="hls ps18" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:10.62mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs28">지급내역 수신용)</span>
            <span class="hrt cs18">&nbsp;</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:66.69mm;width:118.09mm;height:27.90mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI">
            <div class="hls ps29" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:116.59mm;">
            <span class="hrt cs16">010-6364-0638 &nbsp;&nbsp;&nbsp;[</span>
            <span class="hrt cs18">✓</span>
            <span class="hrt cs16">] 문자메시지&nbsp;</span>
            <span class="hrt cs18">수신동의&nbsp;</span>
            <span class="hrt cs4">&nbsp;</span>
            </div>
            <div class="hls ps46" style="line-height:2.48mm;white-space:nowrap;left:0mm;top:6.19mm;height:3.17mm;width:116.59mm;">
            </div>
            <div class="hls ps30" style="line-height:2.48mm;white-space:nowrap;left:0mm;top:11.91mm;height:3.17mm;width:116.59mm;">
            </div>
            <div class="hls ps31" style="line-height:2.48mm;white-space:nowrap;left:0mm;top:13.18mm;height:3.17mm;width:116.59mm;">
            <span class="hrt cs4">※&nbsp;</span>
            <span class="hrt cs29">위임처리결과 및 지급내역 등을 전송받을 연락처로 정확히 적어 주시기 바랍니</span>
            </div>
            <div class="hls ps31" style="padding-left:4.76mm;line-height:2.48mm;white-space:nowrap;left:0mm;top:17.95mm;height:3.17mm;width:116.59mm;">
            <span class="hrt cs29">다</span>
            <span class="hrt cs30">.</span>
            </div>
            <div class="hls ps32" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:22.70mm;height:3.53mm;width:116.59mm;">
            <span class="hrt cs4">&nbsp;&nbsp;&nbsp;(문자메시지 수신을 동의한 경우에만 발송)</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:0mm;top:94.59mm;width:27.69mm;height:35.80mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:14.96mm;">
            <div class="hls ps32" style="line-height:3.10mm;white-space:nowrap;left:0mm;top:-0.19mm;height:3.88mm;width:25.68mm;">
            <span class="hrt cs21">② 준요양기관</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:27.69mm;top:94.59mm;width:26.23mm;height:8.47mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.72mm;">
            <div class="hls ps1" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs20">상호</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:94.59mm;width:118.09mm;height:8.47mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.90mm;">
            <div class="hls ps0" style="line-height:2.48mm;white-space:nowrap;left:0mm;top:-0.16mm;height:3.17mm;width:116.59mm;">
            <span class="hrt cs31">솔닥 주식회사</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:27.69mm;top:103.06mm;width:26.23mm;height:9.61mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI">
            <div class="hls ps22" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs20">사업자등록번호</span>
            </div>
            <div class="hls ps22" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:4.41mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs31">(법인등록번호)</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:103.06mm;width:118.09mm;height:9.61mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:2.29mm;">
            <div class="hls ps0" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:116.59mm;">
            <span class="hrt cs20">284-87-00967</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:27.69mm;top:112.67mm;width:26.23mm;height:8.47mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.72mm;">
            <div class="hls ps1" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs20">대표자&nbsp;</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:112.67mm;width:118.09mm;height:8.47mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.72mm;">
            <div class="hls ps0" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:116.59mm;">
            <span class="hrt cs20">김민승, 이호익</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:27.69mm;top:121.13mm;width:26.23mm;height:9.26mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI">
            <div class="hls ps22" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs18">전화번호</span>
            </div>
            <div class="hls ps22" style="line-height:2.48mm;white-space:nowrap;left:0mm;top:4.43mm;height:3.17mm;width:24.74mm;">
            <span class="hrt cs4">(휴대전화번호)</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:121.13mm;width:118.09mm;height:9.26mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:2.12mm;">
            <div class="hls ps17" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:116.59mm;">
            <span class="hrt cs18">02-6269-7676</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:0mm;top:130.39mm;width:27.69mm;height:33.97mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:10.74mm;">
            <div class="hls ps33" style="line-height:3.10mm;white-space:nowrap;left:0mm;top:-0.19mm;height:3.88mm;width:25.68mm;">
            <span class="hrt cs21">③&nbsp;</span>
            <span class="hrt cs33">요양비 수</span>
            </div>
            <div class="hls ps33" style="padding-left:5.39mm;line-height:3.10mm;white-space:nowrap;left:0mm;top:6.41mm;height:3.88mm;width:25.68mm;">
            <span class="hrt cs33">령</span>
            <span class="hrt cs21">계좌</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:27.69mm;top:130.39mm;width:26.23mm;height:8.49mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.73mm;">
            <div class="hls ps27" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs20">수령자</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:130.39mm;width:118.09mm;height:8.49mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI">
            <div class="hls ps0" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:116.59mm;">
            <span class="hrt cs20">솔닥 주식회사</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:27.69mm;top:138.88mm;width:26.23mm;height:25.47mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:10.22mm;">
            <div class="hls ps27" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:24.74mm;">
            <span class="hrt cs20">수령계좌&nbsp;</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:138.88mm;width:52mm;height:8.49mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.73mm;">
            <div class="hls ps0" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:50.50mm;">
            <span class="hrt cs20">&nbsp;&nbsp;금융기관명</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:105.92mm;top:138.88mm;width:66.08mm;height:8.49mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.73mm;">
            <div class="hls ps1" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:64.59mm;">
            <span class="hrt cs20">하나은행</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:147.37mm;width:52mm;height:8.49mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.73mm;">
            <div class="hls ps17" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:50.50mm;">
            <span class="hrt cs18">&nbsp;&nbsp;예금주</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:105.92mm;top:147.37mm;width:66.08mm;height:8.49mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.73mm;">
            <div class="hls ps1" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:64.59mm;">
            <span class="hrt cs18">솔닥 주식회사</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:53.92mm;top:155.86mm;width:52mm;height:8.49mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.73mm;">
            <div class="hls ps17" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:50.50mm;">
            <span class="hrt cs18">&nbsp;&nbsp;계좌번호&nbsp;</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:105.92mm;top:155.86mm;width:66.08mm;height:8.49mm;">
            <div class="hcD" style="left:1mm;top:1.73mm;">
            <div class="hcI">
            <div class="hls ps1" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:64.59mm;">
            <span class="hrt cs18">204-910028-65104</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:0mm;top:164.36mm;width:27.69mm;height:48.35mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:21.24mm;">
            <div class="hls ps34" style="line-height:3.10mm;white-space:nowrap;left:0mm;top:-0.19mm;height:3.88mm;width:25.68mm;">
            <span class="hrt cs21">④ 위임사항</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:27.69mm;top:164.36mm;width:144.32mm;height:48.35mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI">
            <div class="hls ps19" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:142.31mm;">
            <span class="hrt cs18">&nbsp;1)&nbsp;</span>
            <span class="hrt cs16">[ &nbsp;]&nbsp;</span>
            <span class="hrt cs18">자동복막투석 소모성 재료 &nbsp;</span>
            <span class="hrt cs16">&nbsp;&nbsp;&nbsp;[ &nbsp;] 복막관류액</span>
            </div>
            <div class="hls ps19" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:4.41mm;height:3.53mm;width:142.31mm;">
            <span class="hrt cs18">&nbsp;2)&nbsp;</span>
            <span class="hrt cs16">[ &nbsp;] 가정용&nbsp;</span>
            <span class="hrt cs18">산소발생기 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="hrt cs16">[ &nbsp;] 휴대용&nbsp;</span>
            <span class="hrt cs18">산소발생기</span>
            </div>
            <div class="hls ps19" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:9mm;height:3.53mm;width:142.31mm;">
            <span class="hrt cs18">&nbsp;3)&nbsp;</span>
            <span class="hrt cs16">[&nbsp;</span>
            <span class="hrt cs1">✓&nbsp;</span>
            <span class="hrt cs16">] 당뇨병 소모성 재료 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[&nbsp;</span>
            <span class="hrt cs18">✓</span>
            <span class="hrt cs16">&nbsp;] 연속혈당측정용 전극(센서)</span>
            </div>
            <div class="hls ps19" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:13.58mm;height:3.53mm;width:142.31mm;">
            <span class="hrt cs18">&nbsp;4)&nbsp;</span>
            <span class="hrt cs16">[ &nbsp;]&nbsp;</span>
            <span class="hrt cs18">자가도뇨 소모성 재료&nbsp;</span>
            </div>
            <div class="hls ps19" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:18.17mm;height:3.53mm;width:142.31mm;">
            <span class="hrt cs18">&nbsp;5)&nbsp;</span>
            <span class="hrt cs16">[ &nbsp;]&nbsp;</span>
            <span class="hrt cs18">인공호흡기 및 기본소모품&nbsp;</span>
            <span class="hrt cs16">&nbsp;&nbsp;&nbsp;&nbsp;[ &nbsp;] 선택소모품</span>
            <span class="hrt cs18">&nbsp;</span>
            </div>
            <div class="hls ps19" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:22.75mm;height:3.53mm;width:142.31mm;">
            <span class="hrt cs18">&nbsp;6)&nbsp;</span>
            <span class="hrt cs16">[ &nbsp;]&nbsp;</span>
            <span class="hrt cs18">기침유발기&nbsp;</span>
            </div>
            <div class="hls ps19" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:27.34mm;height:3.53mm;width:142.31mm;">
            <span class="hrt cs18">&nbsp;7)&nbsp;</span>
            <span class="hrt cs16">[ &nbsp;]&nbsp;</span>
            <span class="hrt cs18">양압기 및&nbsp;</span>
            <span class="hrt cs16">소모품</span>
            </div>
            <div class="hls ps19" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:31.93mm;height:3.53mm;width:142.31mm;">
            <span class="hrt cs18">&nbsp;8)&nbsp;</span>
            <span class="hrt cs16">[&nbsp;</span>
            <span class="hrt cs18">✓</span>
            <span class="hrt cs16">&nbsp;]&nbsp;</span>
            <span class="hrt cs18">연속혈당측정기&nbsp;</span>
            <span class="hrt cs16">&nbsp;</span>
            <span class="hrt cs18">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="hrt cs16">[ &nbsp;]&nbsp;</span>
            <span class="hrt cs18">인슐린자동주입기</span>
            </div>
            <div class="hls ps19" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:36.51mm;height:3.53mm;width:142.31mm;">
            <span class="hrt cs18">&nbsp;9)&nbsp;</span>
            <span class="hrt cs16">[ &nbsp;] 출산비</span>
            </div>
            <div class="hls ps35" style="line-height:2.48mm;white-space:nowrap;left:0mm;top:41.12mm;height:3.17mm;width:142.31mm;">
            </div>
            <div class="hls ps31" style="line-height:2.48mm;white-space:nowrap;left:0mm;top:43.02mm;height:3.17mm;width:142.31mm;">
            <span class="hrt cs29">&nbsp;※ &nbsp;[✔]표시, 중복 표시 가능&nbsp;</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:0mm;top:212.71mm;width:27.69mm;height:7.73mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:0.92mm;">
            <div class="hls ps34" style="line-height:3.10mm;white-space:nowrap;left:0mm;top:-0.19mm;height:3.88mm;width:25.68mm;">
            <span class="hrt cs21">⑤ 위임기간</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:27.69mm;top:212.71mm;width:144.32mm;height:7.73mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:0.92mm;">
            <div class="hls ps34" style="line-height:3.10mm;white-space:nowrap;left:0mm;top:-0.19mm;height:3.88mm;width:142.31mm;">
            <span class="hrt cs21">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2025 년 &nbsp;10 월 &nbsp;17 일부터 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2025 년 10 월 &nbsp;17 일까지 (최장 5년)</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:0mm;top:220.43mm;width:172mm;height:14.01mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.07mm;">
            <div class="hls ps36" style="line-height:2.79mm;white-space:nowrap;left:1.06mm;top:-0.18mm;height:3.53mm;width:167.88mm;">
            <span class="hrt cs16">&nbsp;&nbsp;「국민건강보험법」 제49조제3항 및 같은 법 시행규칙 제23조제3항에 따라 요양비 지급 청구에 관한&nbsp;</span>
            </div>
            <div class="hls ps36" style="padding-left:1.76mm;line-height:2.79mm;white-space:nowrap;left:1.06mm;top:6.17mm;height:3.53mm;width:167.88mm;">
            <span class="hrt cs16">사항을 위와 같이 위임합니다.</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:0mm;top:234.44mm;width:172mm;height:6.95mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:0.89mm;">
            <div class="hls ps20" style="line-height:2.48mm;white-space:nowrap;left:0mm;top:-0.16mm;height:3.17mm;width:168.23mm;">
            <span class="hrt cs4">&nbsp;&nbsp;&nbsp;2025년 &nbsp;&nbsp;&nbsp;&nbsp;10월 &nbsp;&nbsp;&nbsp;&nbsp;17일</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:0mm;top:241.38mm;width:102.93mm;height:7.06mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:0.77mm;">
            <div class="hls ps15" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:100.92mm;">
            <span class="hrt cs18">위임인</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:102.93mm;top:241.38mm;width:69.08mm;height:7.06mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:1.12mm;">
            <div class="hls ps20" style="line-height:2.17mm;white-space:nowrap;left:0mm;top:-0.14mm;height:2.82mm;width:65.31mm;">
            <span class="hrt cs2">이승도 (서명 또는 인)</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:0mm;top:248.45mm;width:172mm;height:11.17mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI">
            <div class="hls ps47" style="line-height:2.79mm;white-space:nowrap;left:0mm;top:-0.18mm;height:3.53mm;width:170mm;">
            <span class="hrt cs49">※ 국민건강보험법 시행규칙 제23조제4항에 따라, 위임하는 사람의 신분증 사본과 준요양기관 대표자&nbsp;</span>
            </div>
            <div class="hls ps47" style="padding-left:5.67mm;line-height:2.79mm;white-space:nowrap;left:0mm;top:5.47mm;height:3.53mm;width:170mm;">
            <span class="hrt cs49">신분증 또는 사업자등록증 사본을 각각 제출하셔야 합니다.</span>
            </div>
            </div>
            </div>
            </div>
            <div class="hce" style="left:0mm;top:259.62mm;width:172mm;height:2.78mm;">
            <div class="hcD" style="left:1mm;top:1mm;">
            <div class="hcI" style="top:0.04mm;">
            <div class="hls ps37" style="line-height:0.50mm;white-space:nowrap;left:0mm;top:-0.04mm;height:0.71mm;width:170mm;">
            </div>
            </div>
            </div>
            </div>
            </div>
            </div>
            </div>
            </div>
        </div>    
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            name: '이승도'
        }
    }
}
</script>

<style scoped>
    .contract-back {
        overflow: auto;
        width: 400px;
        height: 600px;
        
    }   
.hce {margin:0;padding:0;position:absolute;overflow:hidden;}
.hme {margin:0;padding:0;position:absolute;}
.hhe {margin:0;padding:0;position:relative;}
.hhi {display:inline-block;margin:0;padding:0;position:relative;background-size:contain;}
.hls {margin:0;padding:0;position:absolute;}
.hfS {margin:0;padding:0;position:absolute;}
.hcD {margin:0;padding:0;position:absolute;}
.hcI {margin:0;padding:0;position:absolute;}
.hcS {margin:0;padding:0;position:absolute;}
.hfN {margin:0;padding:0;position:relative;}
.hmB {margin:0;padding:0;position:absolute;}
.hmO {margin:0;padding:0;position:absolute;}
.hmT {margin:0;padding:0;position:absolute;}
.hpN {display:inline-block;margin:0;padding:0;position:relative;white-space:nowrap;}
.htC {display:inline-block;margin:0;padding:0;position:relative;vertical-align:top;overflow:hidden;}
.haN {display:inline-block;margin:0;padding:0;position:relative;}
.hdu {margin:0;padding:0;position:relative;}
.hdS {margin:0;padding:0;position:absolute;}
.hsC {margin:0;padding:0;position:absolute;}
.hsR {margin:0;padding:0;position:absolute;}
.hsG {margin:0;padding:0;position:absolute;}
.hsL {margin:0;padding:0;position:absolute;}
.hsT {margin:0;padding:0;position:absolute;overflow:hidden;}
.hsE {margin:0;padding:0;position:absolute;overflow:hidden;}
.hsA {margin:0;padding:0;position:absolute;overflow:hidden;}
.hsP {margin:0;padding:0;position:absolute;overflow:hidden;}
.hsV {margin:0;padding:0;position:absolute;overflow:hidden;}
.hsO {margin:0;padding:0;position:absolute;}
.hsU {margin:0;padding:0;position:absolute;overflow:hidden;}
.hpi {margin:0;padding:0;position:absolute;}
.hch {margin:0;padding:0;position:absolute;}
.hcG {margin:0;padding:0;position:absolute;}
.heq {margin:0;padding:0;position:absolute;}
.heG {margin:0;padding:0;position:absolute;}
.htA {margin:0;padding:0;position:absolute;}
.hvi {margin:0;padding:0;position:absolute;}
.htb {margin:0;padding:0;position:absolute;}
.htG {margin:0;padding:0;position:absolute;}
.hfJ {margin:0;padding:0;position:absolute;}
.hfG {margin:0;padding:0;position:absolute;}
.hfB {margin:0;padding:0;position:absolute;}
.hfR {margin:0;padding:0;position:absolute;}
.hfC {margin:0;padding:0;position:absolute;}
.hfO {margin:0;padding:0;position:absolute;}
.hfL {margin:0;padding:0;position:absolute;}
.hfM {margin:0;padding:0;position:absolute;}
.hfE {margin:0;padding:0;position:absolute;}
.hpl {margin:0;padding:0;position:absolute;}
.hs {margin:0;padding:0;position:absolute;overflow:visible;}
.hpa {position:relative;padding:0;overflow:hidden;margin:0;}
.hpa::after {content:'';position:absolute;margin:0;padding:0;left:0;right:0;top:0;bottom:0;background-color:white;z-index:-2;}
.hrt {display:inline-block;margin:0;padding:0;position:relative;white-space:inherit;line-height:1.1;}
.hco {display:inline-block;margin:0;padding:0;position:relative;white-space:inherit;}
.hcc {margin:0;padding:0;position:absolute;}
.hls {clear:both;}
[onclick] {cursor:pointer;}
.cs0 {font-size:8pt;color:#000000;font-family:"돋움체";}
.cs1 {font-size:8pt;color:#000000;font-family:"돋움체";}
.cs2 {font-size:9pt;color:#000000;font-family:"돋움체";}
.cs3 {font-size:9pt;color:#000000;font-family:"돋움체";}
.cs4 {font-size:10pt;color:#000000;font-family:"돋움";}
.cs5 {font-size:11pt;color:#000000;font-family:"";font-weight:bold;}
.cs6 {font-size:10pt;color:#000000;font-family:"함초롬바탕";}
.cs7 {font-size:13pt;color:#0000FF;font-family:"돋움";font-weight:bold;}
.cs8 {font-size:8pt;color:#000000;font-family:"돋움";}
.cs9 {font-size:10pt;color:#000000;font-family:"함초롬돋움";}
.cs10 {font-size:9pt;color:#000000;font-family:"함초롬돋움";}
.cs11 {font-size:9pt;color:#000000;font-family:"함초롬바탕";}
.cs12 {font-size:9pt;color:#000000;font-family:"함초롬돋움";letter-spacing:-0.05em;}
.cs13 {font-size:8pt;color:#000000;font-family:"돋움체";}
.cs14 {font-size:10pt;color:#FF0000;font-family:"돋움체";letter-spacing:-0.03em;}
.cs15 {font-size:10pt;color:#000000;font-family:"돋움체";}
.cs16 {font-size:8pt;color:#000000;background-color:#FFFFFF;font-family:"돋움체";}
.cs17 {font-size:10pt;color:#000000;font-family:"돋움체";}
.cs18 {font-size:11pt;color:#000000;font-family:"돋움체";}
.cs19 {font-size:10pt;color:#000000;font-family:"돋움체";letter-spacing:-0.03em;}
.cs20 {font-size:11pt;color:#000000;font-family:"돋움체";}
.cs21 {font-size:10pt;color:#000000;font-family:"돋움";}
.cs22 {font-size:10pt;color:#FF0000;font-family:"돋움체";}
.cs23 {font-size:10pt;color:#FF0000;font-family:"돋움체";}
.cs24 {font-size:8pt;color:#0000FF;background-color:#FFFFFF;font-family:"돋움체";}
.cs25 {font-size:13pt;color:#000000;font-family:"돋움";font-weight:bold;}
.cs26 {font-size:16pt;color:#000000;font-family:"";}
.cs27 {font-size:16pt;color:#0000FF;font-family:"";font-weight:bold;}
.cs28 {font-size:9pt;color:#000000;font-family:"돋움체";letter-spacing:-0.11em;}
.cs29 {font-size:9pt;color:#000000;font-family:"돋움체";letter-spacing:-0.06em;}
.cs30 {font-size:9pt;color:#000000;font-family:"돋움체";letter-spacing:-0.02em;}
.cs31 {font-size:9pt;color:#000000;font-family:"돋움체";letter-spacing:-0.03em;}
.cs32 {font-size:9pt;color:#000000;font-family:"돋움체";}
.cs32::after {content:'';position:absolute;left:0;right:0;top:0;bottom:0;z-index:-1;background-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxsaW5lIHgxPSIwIiB5MT0iNTAlIiB4Mj0iMTAwJSIgeTI9IjUwJSIgc3R5bGU9InN0cm9rZTpyZ2IoMCwwLDApO3N0cm9rZS13aWR0aDowLjJtbSIvPjwvc3ZnPg==');}
.cs33 {font-size:11pt;color:#000000;font-family:"돋움체";letter-spacing:-0.03em;}
.cs34 {font-size:2pt;color:#000000;font-family:"돋움체";}
.cs35 {font-size:10pt;color:#000000;font-family:"돋움체";letter-spacing:-0.04em;}
.cs36 {font-size:10pt;color:#000000;font-family:"돋움체";letter-spacing:-0.02em;}
.cs37 {font-size:16pt;color:#000000;font-family:"함초롬바탕";font-weight:bold;}
.cs38 {font-size:9pt;color:#000000;font-family:"돋움체";font-weight:bold;}
.cs38::after {content:'';position:absolute;left:0;right:0;top:0;bottom:0;z-index:-1;background-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxsaW5lIHgxPSIwIiB5MT0iOTQlIiB4Mj0iMTAwJSIgeTI9Ijk0JSIgc3R5bGU9InN0cm9rZTpyZ2IoMCwwLDApO3N0cm9rZS13aWR0aDowLjJtbSIvPjwvc3ZnPg==');}
.cs39 {font-size:11pt;color:#FF0000;font-family:"돋움체";}
.cs40 {font-size:10pt;color:#000000;font-family:"돋움체";font-weight:bold;}
.cs40::after {content:'';position:absolute;left:0;right:0;top:0;bottom:0;z-index:-1;background-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxsaW5lIHgxPSIwIiB5MT0iOTQlIiB4Mj0iMTAwJSIgeTI9Ijk0JSIgc3R5bGU9InN0cm9rZTpyZ2IoMCwwLDApO3N0cm9rZS13aWR0aDowLjJtbSIvPjwvc3ZnPg==');}
.cs41 {font-size:10pt;color:#0000FF;font-family:"돋움체";font-weight:bold;}
.cs42 {font-size:9pt;color:#000000;font-family:"돋움체";letter-spacing:-0.06em;font-weight:bold;}
.cs42::after {content:'';position:absolute;left:0;right:0;top:0;bottom:0;z-index:-1;background-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxsaW5lIHgxPSIwIiB5MT0iOTQlIiB4Mj0iMTAwJSIgeTI9Ijk0JSIgc3R5bGU9InN0cm9rZTpyZ2IoMCwwLDApO3N0cm9rZS13aWR0aDowLjJtbSIvPjwvc3ZnPg==');}
.cs43 {font-size:9pt;color:#000000;font-family:"돋움체";letter-spacing:-0.02em;font-weight:bold;}
.cs43::after {content:'';position:absolute;left:0;right:0;top:0;bottom:0;z-index:-1;background-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxsaW5lIHgxPSIwIiB5MT0iOTQlIiB4Mj0iMTAwJSIgeTI9Ijk0JSIgc3R5bGU9InN0cm9rZTpyZ2IoMCwwLDApO3N0cm9rZS13aWR0aDowLjJtbSIvPjwvc3ZnPg==');}
.cs44 {font-size:10pt;color:#FF0000;font-family:"돋움체";letter-spacing:-0.03em;font-weight:bold;}
.cs44::after {content:'';position:absolute;left:0;right:0;top:0;bottom:0;z-index:-1;background-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxsaW5lIHgxPSIwIiB5MT0iOTQlIiB4Mj0iMTAwJSIgeTI9Ijk0JSIgc3R5bGU9InN0cm9rZTpyZ2IoMCwwLDApO3N0cm9rZS13aWR0aDowLjJtbSIvPjwvc3ZnPg==');}
.cs45 {font-size:11pt;color:#000000;font-family:"돋움체";font-weight:bold;}
.cs45::after {content:'';position:absolute;left:0;right:0;top:0;bottom:0;z-index:-1;background-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxsaW5lIHgxPSIwIiB5MT0iOTQlIiB4Mj0iMTAwJSIgeTI9Ijk0JSIgc3R5bGU9InN0cm9rZTpyZ2IoMCwwLDApO3N0cm9rZS13aWR0aDowLjJtbSIvPjwvc3ZnPg==');}
.cs46 {font-size:10pt;color:#000000;font-family:"돋움체";letter-spacing:-0.01em;font-weight:bold;}
.cs47 {font-size:8pt;color:#FF0000;background-color:#FFFFFF;font-family:"돋움체";}
.cs48 {font-size:8pt;color:#FF0000;font-family:"돋움체";}
.cs49 {font-size:10pt;color:#FF0000;font-family:"돋움";}
.cs50 {font-size:10pt;color:#000000;font-family:"돋움체";letter-spacing:-0.07em;}
.cs51 {font-size:10pt;color:#000000;font-family:"돋움체";letter-spacing:-0.01em;}
.ps0 {text-align:justify;}
.ps1 {text-align:center;}
.ps2 {text-align:center;}
.ps3 {text-align:center;}
.ps4 {text-align:left;}
.ps5 {text-align:justify;}
.ps6 {text-align:justify;}
.ps7 {text-align:justify;}
.ps8 {text-align:justify;}
.ps9 {text-align:justify;}
.ps10 {text-align:justify;}
.ps11 {text-align:justify;}
.ps12 {text-align:justify;}
.ps13 {text-align:justify;}
.ps14 {text-align:justify;}
.ps15 {text-align:right;}
.ps16 {text-align:justify;}
.ps17 {text-align:justify;}
.ps18 {text-align:center;}
.ps19 {text-align:justify;}
.ps20 {text-align:right;}
.ps21 {text-align:right;}
.ps22 {text-align:center;}
.ps23 {text-align:justify;}
.ps24 {text-align:center;}
.ps25 {text-align:justify;}
.ps26 {text-align:justify;}
.ps27 {text-align:center;}
.ps28 {text-align:justify;}
.ps29 {text-align:right;}
.ps30 {text-align:justify;}
.ps31 {text-align:justify;}
.ps32 {text-align:justify;}
.ps33 {text-align:justify;}
.ps34 {text-align:justify;}
.ps35 {text-align:justify;}
.ps36 {text-align:justify;}
.ps37 {text-align:right;}
.ps38 {text-align:justify;}
.ps39 {text-align:justify;}
.ps40 {text-align:justify;}
.ps41 {text-align:justify;}
.ps42 {text-align:justify;}
.ps43 {text-align:justify;}
.ps44 {text-align:center;}
.ps45 {text-align:justify;}
.ps46 {text-align:justify;}
.ps47 {text-align:justify;}
.ps48 {text-align:justify;}
.ps49 {text-align:justify;}
.ps50 {text-align:justify;}
.ps51 {text-align:justify;}
.ps52 {text-align:justify;}

</style>


// WEBPACK FOOTER //
// src/components/atoms/ContractBack.vue